import { useGetVersion } from './useVersion'

const version = {
  get: useGetVersion,
}

export default version
